<template>
<div class="odr-linemenu">
    <div class="odr-linemenu__options">
        <button v-for="(item, index) in options"
                :key="item.id"
                ref="item"
                type="button"
                :data-qa="dataQa ? dataQa + '.' + item.id : null"
                class="odr-linemenu__item"
                :class="{'odr-linemenu__item_choosed': multiple_get(item)}"
                @click="() => { multiple_input(item) }"
                @focus="() => {$emit('focus')}"
                @blur="() => {$emit('blur')}"
                @mouseover="event => {handleArrows(index, 0); event.preventDefault()}"
                @mouseout="() => {leaveFocus(index)}"
                @keydown.down="event => {handleArrows(index, 1); event.preventDefault()}"
                @keydown.up="event => {handleArrows(index, -1); event.preventDefault()}"
                @keydown.tab="event => {$emit('finished'); event.preventDefault()}">
            <span class="odr-linemenu__wrapper">
                <div class="odr-linemenu__text">
                    <tpl :content="(item.icon ? `<icon alt='${item.alt}'>${item.icon}</icon> `: '') + (item.description || item.title || item.match)"/>
                </div>
                <div v-if="multiple_get(item)" class="odr-linemenu__text odr-linemenu__text_arrow">
                    <icon>done</icon>
                </div>
            </span>
        </button>
    </div>
    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">
        {{ validation_error }}
    </div>
</div>
</template>

<script>
import '@/scss/blocks/error-message.scss';

import validationMixin from '@/utils/mixins/validation';
import focusMixin from '@/utils/mixins/focus';
import multipleMixin from '@/utils/mixins/multiple';
import orderMixin from '@/utils/mixins/order';

export default {
    mixins: [validationMixin, focusMixin, orderMixin, multipleMixin],
    props: ['dataQa', 'value', 'values', 'title'],
    computed: {
        options () {
            return this.order_options(this.values);
        },
    },
    methods: {
        focus_focus () {
            // if (this.$refs.item && this.$refs.item[0]) {
            //     this.$refs.item[0].focus();
            // }
        },
        validation_isEmpty () {
            return this.multiple_selected.length === 0;
        },
        handleArrows (index, delta) {
            let element = this.$refs.item[index + delta];
            if (element) {
                element.focus();
            }
        },
        leaveFocus (index) {
            let element = this.$refs.item[index];
            if (element) {
                element.blur();
            }
        },
    },
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
};
</script>
